import * as Yup from "yup";
import dayjs from "dayjs";

export const validateRowSchema = Yup.object().shape({
    // itemId: Yup
    //     .string(),
        // .required("Required"),
    id: Yup
        .string()
        .required("Required"),
    docItemId: Yup
        .string()
        .required("Required"),
    inventoryIndexNo: Yup
        .string()
        .required("Required"),
    // slotId: Yup
    //     .string()
    //     .required("Required"),
    // customBatchNo: Yup
    //     .string()
    //     .required("Required")
})

export const validationSchema = Yup.object({ 
    documentDate: Yup
        // .string()
        .date("Invalid")
        .required("Required")
        .typeError("Invalid"),
    rows: Yup.array().of(validateRowSchema)
})

export const initialRowValues = {
    // itemId: "",
    id: "",
    docItemId: "",
    requiredQty: "",
    inventoryIndexNo: 0,
    slotId: "",
    customBatchNo: "",
    expiryDate: "",
    isStockPost: false,
}

export const initialValues = {
    documentDate: "",
    documentNumber: "",
    status: false,
    isStockPost: false,
    remark: "",
    userid: "",
    rows: [initialRowValues],
}